import React from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import Profile from "./components/Profile";

interface HeaderProps {
  setActiveComponent: (component: string) => void;
  activeComponent: string;
  onOpenMobileSidebar?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  setActiveComponent,
  activeComponent,
  onOpenMobileSidebar,
}) => {
  const title =
    activeComponent.charAt(0).toUpperCase() + activeComponent.slice(1);

  return (
    <header className="px-4 pt-4 pb-1 lg:px-0 lg:pt-0 ">
      <div className="relative flex items-center justify-between gap-4 rounded-[30px] bg-[linear-gradient(180deg,#ffffff_0%,#f8fbfb_100%)] px-4 py-4 shadow-[0_24px_70px_rgba(15,23,42,0.08)] ring-1 ring-slate-200/70 lg:-ml-px lg:rounded-l-none lg:rounded-r-none lg:px-6">
        {onOpenMobileSidebar && (
          <button
            type="button"
            onClick={onOpenMobileSidebar}
            className="absolute left-4 top-1/2 z-10 -translate-y-1/2 p-2 text-slate-700 hover:text-slate-900 lg:hidden"
            aria-label="Open navigation menu"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
        )}
        <div className="pl-12 lg:pl-0">
          <h1 className="text-2xl font-semibold tracking-[-0.03em] text-primary lg:text-[2rem]">
            {title}
          </h1>
        </div>

        <div className="flex items-center gap-3">
          <Profile setActiveComponent={setActiveComponent} />
        </div>
      </div>
    </header>
  );
};

export default Header;
